import { createSlice } from '@reduxjs/toolkit'
import {getVenuesTemp} from "@/store/venue-summary-temp/action";

const initialState = {
  state: {
    venues: [],
    paging: {
      page: 0,
      size: 0,
      total_page: 0,
      total_size: 0
    }
  },
  loading: true,
  error: ''
} as BaseState<VenueSummaryTempState>

const slice = createSlice({
  name: 'venueSummaryTempSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVenuesTemp.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(getVenuesTemp.fulfilled, (state, action) => {
      const { items, paging } = action.payload
      return {
        state: {
          paging,
          venues: items
        },
        loading: false,
        error: null
      }
    })
    builder.addCase(getVenuesTemp.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get Venues'
    }))
  }
})

export default slice